<route>
{
  "name": "Documentos"
}
</route>
<template>
  <div>
    <base-header class="pb-5 pt-4">
      <h4 class="text-white hidden-up-md">Documentos</h4>
    </base-header>
    <div class="container-fluid mt-4 pt-2">
      <div class="row">
        <div class="col">
          <div class="card shadow px-4 py-3">
            <div class="row align-items-center">
              <div class="col u-flex">
                <h3 class="mb-0">{{condominios[0].nome}}</h3>
              </div>
              <div class="col text-right">
                <slot name="header-right"></slot>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="container-fluid mt-2" v-if="tipos && tipos.length">
      <tabs ref="tabs" :value="tipos[0].name">
        <tab-pane v-for="t in tipos" :key="t.tipo.id" :id="t.tipo.id" :title="t.tipo.name">
          <span slot="title">
              {{ t.tipo.name }}
              <badge type="default" circle class="text-white">{{ t.quantidade }}</badge>
          </span>
          <div class="card shadow cards-table">
            <div class="table-responsive">          
              <vue-good-table v-if="documentos[t.tipo.id] && documentos[t.tipo.id].length" styleClass="vgt-table striped" :columns="columns" :rows="documentos[t.tipo.id]" :paginationOptions="paginationOptions" compactMode>
                <template slot="table-row" slot-scope="props">
                    <div v-if="props.column.field == 'acoes'">
                      <base-button
                        type="success"
                        class="text-white"
                        :href="props.row.link"
                        tag="a"
                        size="sm"
                        icon="fa fa-eye"
                        target="_blank"
                      >Ver</base-button>
                    </div>
                    <span v-else>
                      {{props.formattedRow[props.column.field]}}
                    </span>
                </template>
              </vue-good-table>
              <div class="cadastro-reservas--vazio px-3 pt-3" v-else>
                <base-alert type="primary">
                  Nenhum documento do tipo {{ t.tipo.name }}
                </base-alert>
              </div>
            </div>
          </div>
        </tab-pane>
      </tabs>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";

export default {
  computed: {
    ...mapState("documentos", {
      documentos: "documentos",
      tipos: "tipos"
    }),
    ...mapState("auth", ['condominios']),
  },
  data() {
    return {
      columns: [
        { label: 'Data', field: 'data', type: 'date', dateInputFormat: 'yyyy-MM-dd\'T\'HH:mm:ss', dateOutputFormat: 'dd/MM/yyyy' },
        { label: 'Descrição', field: 'descricao' },
        { label: 'Arquivo', field: 'nomeArquivo' },
        { label: 'Ações', field: 'acoes' },
      ],
      paginationOptions: {
        enabled: true,
        mode: 'records',
        perPage: 10,
        position: 'top',
        perPageDropdown: [10, 15, 20],
        dropdownAllowAll: true,
        nextLabel: 'Próximo',
        prevLabel: 'Anterior',
        rowsPerPageLabel: 'Documentos por página',
        ofLabel: 'de',
        pageLabel: 'página', // for 'pages' mode
        allLabel: 'Todos',
      }
    }
  },
  created() {
    this.carregarTipos(this.$route.params.id).then(async () => {
      await Promise.all(this.tipos.map((t) => this.carregarDocumentosPorTipo({ id: this.$route.params.id, tipo: t.tipo.id })))
    });
  },
  methods: {
    ...mapActions("documentos", ["carregarTipos", "carregarDocumentosPorTipo"])
  },
};
</script>

<style>
</style>